import { ChangeDetectionStrategy, Component, ElementRef, inject, viewChild } from '@angular/core';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';
import { FindMyAgentCtaBannerComponent } from '@rma/finder/agent-finder/public/ui-find-my-agent-cta-banner';
import { ScrollSyncGroup } from '@rma/generic/ui/scroll-sync';
import { YieldToDirective } from '@rma/generic/ui/yield-to';
import { CalloutComponent } from '@rma/public/generic/ui/callout';
import { SkeletonGridComponent } from '@rma/public/generic/ui/skeleton';
import { FeatureFlags, featureFlagSignal } from '@rma/public/generic/util/feature-flags';
import { COMPARE_AGENT_SCOPE } from '../domain/translation-scope';
import { CompareAgentStore } from '../orc-compare-agent/compare-agent.store';
import { CompareAgentsMapSectionComponent } from '../orc-compare-agents-map/compare-agents-map-section.component';
import { AgentCardsRowComponent } from '../ui-agent-cards-row/agent-cards-row.component';
import { OverallInformationSectionComponent } from '../ui-comparison-table/overall-information-section.component';
import { SalesPerformanceSectionComponent } from '../ui-comparison-table/sales-performance-section.component';
import { LoginGateComponent } from '../ui-login-gate/login-gate.component';
import { NoAgentsComponent } from '../ui-no-agents/no-agents.component';

@Component({
  selector: 'rma-compare-agents-layout',
  templateUrl: './compare-agents-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CompareAgentStore, ScrollSyncGroup, provideTranslocoScope(COMPARE_AGENT_SCOPE)],
  imports: [
    AgentCardsRowComponent,
    CalloutComponent,
    FindMyAgentCtaBannerComponent,
    LoginGateComponent,
    NoAgentsComponent,
    OverallInformationSectionComponent,
    CompareAgentsMapSectionComponent,
    SalesPerformanceSectionComponent,
    SkeletonGridComponent,
    TranslocoDirective,
    YieldToDirective,
  ],
  host: {
    class: 'max-w-[100vw] lg:max-w-7xl w-full mx-auto py-8 px-4 xl:px-0',
  },
})
export class CompareAgentsLayoutComponent {
  protected readonly mapSection = viewChild(CompareAgentsMapSectionComponent, { read: ElementRef });

  protected readonly scope = COMPARE_AGENT_SCOPE;
  protected readonly store = inject(CompareAgentStore);
  protected readonly buyersAgentEnabled = featureFlagSignal(FeatureFlags.EnableBuyerAgents, false);
}
